import { ISelect } from 'ufinet-web-components'

export const getDefaultOption = (options: ISelect[], defaultValue: string | undefined) =>
	defaultValue ? options.find((opt) => opt.value === defaultValue) : undefined
